import { ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { KeycloakService } from 'keycloak-angular';
import { initializeKeycloak } from './service/auth/keycloak.factory';
import { ErrorsInterceptor } from './service/interceptor/errors.interceptor';
import { AuthInterceptor } from './service/interceptor/auth.interceptor';
import { provideQuillConfig } from 'ngx-quill';
import { provideIcons } from '@ng-icons/core';
import { provideSpartanHlm } from '@spartan-ng/helm/utils';
import { APP_ICONS } from './shared/icons/app-icons';
import { provideSpartanItalian } from './shared/spartan/spartan-italian';
import { routes } from './app.routes';

registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    { provide: LOCALE_ID, useValue: 'it-IT' },

    provideQuillConfig({}),
    provideSpartanHlm(),
    provideSpartanItalian(),
    provideIcons(APP_ICONS),

    provideHttpClient(withInterceptorsFromDi()),

    KeycloakService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService]
    },

    { provide: HTTP_INTERCEPTORS, useClass: ErrorsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ]
};
